import { render, staticRenderFns } from "./PackageEdit.vue?vue&type=template&id=61f84616&"
import script from "./PackageEdit.vue?vue&type=script&lang=js&"
export * from "./PackageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports